<template>
  <div
    v-if="showPrompt"
    class="mb-7 last:mb-0 text-center"
  >
    <p
      v-if="promptText"
      class="mb-4"
      :class="`text-${textColor}`"
      v-html="promptText"
    />
    <MultiBtn
      v-if="promptButton && btnRouteTo"
      :routeTo="btnRouteTo"
      icon="arrow"
      :theme="btnStyle"
      :text="promptButton.btn_text"
      :label="promptButton.btn_title"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MultiBtn from '@/components/buttons/MultiBtn.vue'

export default {
  name: 'JustExplorePrompt',

  components: {
    MultiBtn
  },

  computed: {
    ...mapGetters([
      'justExplorePage',
      'myStore'
    ]),
    // Text
    textColor() { return this.myStore(['styles', 'just_explore_prompt', 'prompt_text', 'text_color']) ?? 'inherit' },
    promptText() { return (this.justExplorePage || {}).prompt_text ?? '' },
    // Btn
    promptButton() { return (this.justExplorePage || {}).prompt_button ?? false },
    btnStyle() { return this.myStore(['styles', 'just_explore_prompt', 'prompt_button', 'button_style']) ?? 'button_style_1' },
    btnRouteTo() {
      return {
        name: 'je-map',
      }
    },
    showPrompt() { return this.justExplorePage && (this.promptButton && this.btnRouteTo) ? true : false }
  },
}
</script>

